import { render, staticRenderFns } from "./ElectricalDamageType.vue?vue&type=template&id=61001bca&scoped=true"
import script from "./ElectricalDamageType.vue?vue&type=script&lang=ts"
export * from "./ElectricalDamageType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61001bca",
  null
  
)

export default component.exports